'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagAnAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M0 0H28V20H0V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M10.6665 0H17.3332V20H10.6665V0Z", fill: "#D6182D" }),
      /* @__PURE__ */ jsx("path", { d: "M0 6.66667H28V13.3333H0V6.66667Z", fill: "#1425A2" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.3332 11.6667L10.8618 11.8048L10.9998 11.3334L10.8618 10.8619L11.3332 11L11.8046 10.8619L11.6665 11.3334L11.8046 11.8048L11.3332 11.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.6667 11.6667L16.1953 11.8047L16.3333 11.3333L16.1953 10.8619L16.6667 11L17.1381 10.8619L17 11.3333L17.1381 11.8047L16.6667 11.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.66667 10.3333L8.19526 10.4714L8.33333 10L8.19526 9.52859L8.66667 9.66667L9.13807 9.52859L9 10L9.13807 10.4714L8.66667 10.3333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.3332 10.3333L18.8618 10.4714L18.9998 9.99998L18.8618 9.52857L19.3332 9.66665L19.8046 9.52857L19.6665 9.99998L19.8046 10.4714L19.3332 10.3333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.0002 9L13.5288 9.13807L13.6668 8.66667L13.5288 8.19526L14.0002 8.33333L14.4716 8.19526L14.3335 8.66667L14.4716 9.13807L14.0002 9Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagAnAsset = forwardRef(FlagAnAsset);

export { VpFlagAnAsset as default };
